
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M17.857 20.417a3.393 3.393 0 003.393-3.39V14.323a2.24 2.24 0 010-4.478h0v-2.7a3.392 3.392 0 00-3.388-3.396H6.144A3.394 3.394 0 002.75 7.142v2.791a2.163 2.163 0 012.237 2.086l.002.066a2.237 2.237 0 01-2.233 2.24H2.75v2.7a3.392 3.392 0 003.391 3.392h11.716z","stroke":"#979797","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M12.371 9.063l.616 1.247c.06.122.176.207.311.227l1.377.201c.341.05.476.468.23.707l-.996.97a.417.417 0 00-.12.367l.235 1.37a.414.414 0 01-.6.437l-1.232-.647a.412.412 0 00-.386 0l-1.23.647a.415.415 0 01-.602-.437l.235-1.37a.414.414 0 00-.12-.367l-.995-.97a.414.414 0 01.23-.707l1.376-.2a.416.416 0 00.312-.228l.615-1.247a.415.415 0 01.744 0z","stroke":"#979797","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    